import React, { useEffect, useState } from 'react';
import Echo from 'laravel-echo';

//PACKS
import { connect } from 'react-redux';
import { Button, Modal, Container, Spinner, Row, Col, Card, Form, Alert } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import Moment from "moment";

//ACTIONS
import { pesquisa as pesquisatraducoes } from '../../../actions/traducoes/traducoes';
import { item } from '../../../actions/produto/item';
import { pesquisaPedidosItens } from '../../../actions/produto/pedidosItens';
import { pesquisa as pesquisapedido } from '../../../actions/pedidos/pedidos';

import { formaPagamento as pesqFormPag } from '../../../actions/produto/formaPagamento';

//TOOLS
import { getTraducaoTrocaPor as trad } from '../../../utils/getTraducoes';
import { validaCarrinho } from '../../../utils/produtosCalculos';

import { getUserLoginCred, setUserProduct, removeUserProduct, removePedidoConfirmado } from '../../../utils/eventosessioncred';

const ProdutosForm = (props) => {

    const [logado, setLogado] = useState(null);
    const [cadastro, setCadastro] = useState(null);
    const [arrPedidosItens, setArrPedidosItens] = useState([]);
    const [traducaocarregada, setTraducaoCarregado] = useState(null);
    const [formaPagamento, setFormaPagamento] = useState();
    const [produtos, setProdutos] = useState();
    const [produtosFiltrados, setProdutosFiltrados] = useState();
    const [produtoSelecionado, setProdutoSelecionado] = useState();
    const [showModalProduto, setShowModalProduto] = useState(false);
    const [statusAceite, setStatusAceite] = useState(false);
    const [carrinhovalido, setCarrinhoValido] = useState(null);

    //const [itensComPedidos, setItensComPedidos] = useState(true);

    const loadItensComPedidos = async (prods = []) => {
        return await props.pesquisaPedidosItens({
            idevento: props.idevento,
            idpromotora: props.idpromotora,
            whereInStatusPedido: JSON.stringify([6]),
            whereInItens: JSON.stringify(prods),
            filtro_campos: 'idsubitems,quantidade,numerovagas'
        });
    }

    Moment.updateLocale('en', {
        weekdaysShort : [
            "Domingo", 
            "Segunda", 
            "Terça", 
            "Quarta", 
            "Quinta", 
            "Sexta", 
            "Sábado"]
    });

    useEffect(() => {
        const fetchData = async () => {            
            const cadastro = getUserLoginCred();
            if(cadastro && cadastro.fisica && cadastro.fisica.idfisica){
                setCadastro(cadastro)
                const pedidosItens = [];
                const pedidos = await props.pesquisapedido({
                    idevento: props.idevento,
                    idpromotora: props.idpromotora,
                    idfisica: cadastro.fisica.idfisica,                        
                    whereInStatusPedido: JSON.stringify([1,2,6]),
                });     
                pedidos.forEach((pedido)=>{                
                    pedido.inscritoitensescolhidos.forEach(item=>pedidosItens.push(item.idsubitems))                 
                });
                setArrPedidosItens(pedidosItens);
            }

            setLogado(cadastro && cadastro.fisica && cadastro.fisica.idfisica ? true : false)
            await handlePesquisaProdutos();
            await handlePesquisaTraducos();
            await handlePesquisaFormaPagamento();
            setTraducaoCarregado(true);
        }
        fetchData();
        removePedidoConfirmado();
    },[]);

    useEffect(() => {
        const fetchData = async () => {
            await handlePesquisaTraducos();
        }
        fetchData();
    }, [props.lingua]);

    const handlePesquisaFormaPagamento = async () => {
        const dados_basico_evento = {
            idevento: props.idevento,
            idpromotora: props.idpromotora
        }
        const [fp] = await props.pesqFormPag(
            {
                ...dados_basico_evento,
                tipopagto: "GR"
            }
        );
        setFormaPagamento(fp);
    }
    const handlePesquisaTraducos = async () => {
        const dados_basico_evento = {
            idevento: props.idevento,
            idpromotora: props.idpromotora
        }
        await props.pesquisatraducoes(
            {
                ...dados_basico_evento,
                wherein: JSON.stringify({
                    campo: 'identificador',
                    valores: ['conf_index']
                })
            }
        );
    }
    const handlePesquisaProdutos = async () => {
        const dados_basico_evento = {
            idevento: props.idevento,
            idpromotora: props.idpromotora
        }
        const produtosFiltrados = await props.item({ ...dados_basico_evento }).then(products => {
            setProdutos(products);
            const groups = products.reduce((groups, prod) => {
                if (prod.tabelaprecos) {
                    var datalimite = Moment(prod.tabelaprecos.datalimite)
                    var agora = Moment();
                    if (agora < datalimite && prod.vernocongresso === "S") {
                        const date = prod.datainicial.split(' ')[0];
                        const horaInicial = Moment(prod.datainicial).format('HH:mm')
                        const horaFinal = Moment(prod.datafinal).format('HH:mm')
                        const vagas = prod.numerovagas
                        if (!groups[date]) {
                            groups[date] = [];
                        }
                        groups[date].push({ ...prod, horaInicial, horaFinal, vagas });
                    }
                }
                return groups;
            }, {});

            // Edit: to add it in the array format instead
            const groupArrays = Object.keys(groups).map((date) => {
                return {
                    date,
                    produtos: groups[date]
                };
            });
            return groupArrays;
        });
                
        let prods_pedidos = [];
        if(produtosFiltrados&&produtosFiltrados.length){
            let prod_ids = [];
            produtosFiltrados.forEach(itens => {
                itens.produtos.forEach(prods => {
                    prod_ids.push(prods.idsubitems);
                });
            });

            prods_pedidos = await loadItensComPedidos(prod_ids);
        }

        if(prods_pedidos.length){
            const new_produtosFiltrados = produtosFiltrados.map(itensfiltrados => {                
                const prods_filtrados = itensfiltrados.produtos.filter(itensfiltrados_prods => {
                    let result = false;
                    prods_pedidos.filter(pedido => {                        
                        if(pedido.idsubitems===itensfiltrados_prods.idsubitems){
                            let qtdepedidototal = 0;
                            pedido.itenescolhido.forEach(itens => {                                
                                qtdepedidototal += itens.quantidade;
                            });
                            result = (pedido.numerovagas-qtdepedidototal)>0?true:false;
                        }
                        return result;
                    });                    
                    return result;
                });
                return {
                    ...itensfiltrados,
                    produtos: prods_filtrados
                };
            });            
            setProdutosFiltrados(new_produtosFiltrados);
        }else{
            setProdutosFiltrados(produtosFiltrados);
        }
    }

    useEffect(() => {
    }, [produtos]);


    const handleClose = () => {
        setShowModalProduto(false);
        setStatusAceite(false);
        setProdutoSelecionado();
    };
    const handleShow = (produto) => {        
        setProdutoSelecionado(produto);
        setShowModalProduto(true);
        setCarrinhoValido(null);
    }

    const handleProduct = () => {

        removeUserProduct();
        const prod = {
            pedido: {
                idstatus: 6,
                idformapagto: formaPagamento.idformapagto,
                vencto: '',
                valorbruto: 0
            },
            produtos: [produtoSelecionado]
        }        
        setUserProduct(prod);

        const check_carrinho = validaCarrinho();
        if(check_carrinho.valido&&check_carrinho.valido===true){
            props.history.push('cadastro');
        }else{
            setShowModalProduto(false);
            setCarrinhoValido(false);
        }
    }

    if (!props.trads.length || traducaocarregada === null) {
        return <Spinner style={{ margin: "auto" }} animation="border" />;
    }
    
    return (
        <Card className="border-0">
            <Card.Title>Selecione dia/turno</Card.Title>
            {carrinhovalido===false?<Alert variant="danger">{trad(props.trads, 'MSGESLCHAPROD', props.lingua)}</Alert>:null}
            <Card.Body className="row justify-content-center">
                {produtosFiltrados.map(produto => {
                    //return <div key={produto.idsubitems}>{produto.portugues}</div> 
                    return (
                        <Card className="text-center" key={produto.date} style={{ width: '18rem' }}>
                            <Card.Title> {
                            produto.date.split("-")[2]+"/"+produto.date.split("-")[1]+"/"+produto.date.split("-")[0]
                            //Moment(produto.date).format('DD/MM/YYYY ddd')
                            }</Card.Title>                            
                            {/* <Card.Title> {Moment(produto.date).format('DD/MM/YYYY ddd')}</Card.Title> */}                            
                            <Card.Body>
                                {produto.produtos.map(prod => {
                                    //<h2>Vagas: {prod.vagas}</h2>
                                    return (
                                        <Button 
                                        key={prod.idsubitems} 
                                        onClick={() => 
                                        handleShow(prod)} 
                                        className="d-block w-100 mb-2" 
                                        variant="primary"
                                        disabled={arrPedidosItens.includes(prod.idsubitems)}>
                                            {prod.portugues}
                                            <h6>{prod.horaInicial} - {prod.horaFinal}</h6>                                            
                                        </Button>
                                    )
                                })}

                            </Card.Body>
                        </Card>
                    )
                })}
                {carrinhovalido===false?<Alert variant="danger">{trad(props.trads, 'MSGESLCHAPROD', props.lingua)}</Alert>:null}
                <Modal show={showModalProduto} onHide={handleClose} backdrop="static" animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>Você selecionou o dia/turno:</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container>
                            <Row>
                                <Col>
                                    {produtoSelecionado && produtoSelecionado.portugues}
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    {produtoSelecionado && produtoSelecionado.descricao_portugues}
                                </Col>
                            </Row>
                            <Row>
                                <Col className="border my-2"
                                style={{ 
                                    height: 100, 
                                    overflowY: 'scroll',
                                    fontSize:10 
                                    }}>
                                    <div>
                                        <b><i>
                                            Estou ciente que devo apresentar o comprovante de vacinação
                                            para participar do evento, de acordo com o decreto
                                            Nº 60.488, publicado no Diário Oficial do Município.
                                            Eventuais exceções deverão ser comprovadas na entrada
                                            do evento. O uso de máscara é obrigatório no interior
                                            do evento.
                                        </i></b>
                                    </div>
                                    <div>
                                        <b><i>
                                            Estou ciente que, ao entrar no recinto de exposições
                                            onde se realiza a Bienal do Livro, Rio de Janeiro,
                                            fica autorizado aos organizadores o uso de sua imagem
                                            pessoal captada no evento, assim como o de menores ou
                                            pessoas sob sua tutela legal para uso em todo e qualquer
                                            material de fotos, vídeos, documentos, meios de comunicação,
                                            campanhas promocionais e institucionais, destinada à
                                            divulgação ao público.
                                        </i></b>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Check type="checkbox" onChange={(e)=>setStatusAceite(!statusAceite)} label="Aceito os termos"/>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Alterar para outro dia/turno
                        </Button>
                        <Button variant="primary" onClick={handleProduct} disabled={!statusAceite}>
                            Continuar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Card.Body>
        </Card>
    )

}

const mapStateToProps = (state) => {
    return {
        trads: state.reducerTraducoes,
        pendingTasks: state.pendingTasks,
        products: state.reducerPesquisaSubitem
    }
}

export default connect(mapStateToProps, {
    pesquisatraducoes,
    item,
    pesqFormPag,
    pesquisaPedidosItens,
    pesquisapedido
})(withRouter(ProdutosForm));